let SQLite = null
try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { Platform } = require('react-native')
    if (Platform?.OS !== 'web') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        SQLite = require('expo-sqlite')
    }
} catch {}
import { isWeb, getPlatform } from '../src/utils/platformUtils'
let __dbModule = null
const buildLocalWrappedDb = () => {
    if (globalThis.__DOTS_SQLITE_WRAPPED_DB) {
        return globalThis.__DOTS_SQLITE_WRAPPED_DB
    }
    try {
    if (!SQLite) throw new Error('SQLite not available (web)')
    const localDb = SQLite.openDatabaseSync('myDB')
        if (getPlatform().OS === 'android') {
            try { localDb.execSync('PRAGMA journal_mode = WAL;') } catch {}
        }
        const wrapStatement = (stmt) => ({
            executeSync: (params = []) => {
                const res = stmt.executeSync(params)
                const rowsArray = Array.isArray(res?.rows) ? res.rows : Array.isArray(res?.rows?._array) ? res.rows._array : []
                return {
                    ...res,
                    getAllSync: () => rowsArray,
                    getFirstSync: () => (rowsArray && rowsArray.length ? rowsArray[0] : null),
                }
            },
            finalizeSync: () => stmt.finalizeSync(),
        })
        const wrapped = {
            execSync: (sql) => localDb.execSync(sql),
            prepareSync: (sql) => {
                const stmt = localDb.prepareSync(sql)
                const wrapped = wrapStatement(stmt)
                return {
                    executeSync: wrapped.executeSync,
                    finalizeSync: wrapped.finalizeSync,
                    getAllSync: (params = []) => wrapped.executeSync(params).getAllSync(),
                    getFirstSync: (params = []) => wrapped.executeSync(params).getFirstSync(),
                }
            },
        }
        globalThis.__DOTS_SQLITE_WRAPPED_DB = wrapped
        return wrapped
    } catch (e) {
        console.error('Fallback SQLite wrapper (errors) failed:', e)
        return null
    }
}
const getWrappedDB = () => {
    if (!__dbModule) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        __dbModule = require('../src/db/indexDB')
    }
    const fromIndex = __dbModule?.getNativeDB ? __dbModule.getNativeDB() : null
    return fromIndex || buildLocalWrappedDb()
}


export const TABLE_ERROR_LOGS = 'error_logs'
const database = 'myDB'


const openDatabase = () => {
    if (isWeb()) {
        // Web: ya resolvemos sin usar DB real en los métodos.
        return { transaction: () => ({ executeSql: () => {} }) }
    }

    const dbSync = getWrappedDB()
    const facade = {
        execSync: (sql) => dbSync.execSync(sql),
        prepareSync: (sql) => dbSync.prepareSync(sql),
        transaction: (callback, errorCallback, successCallback) => {
            try {
                const tx = {
                    executeSql: (sql, params = [], success, error) => {
                        try {
                            const isSelect = /^\s*SELECT/i.test(sql)
                            if (isSelect) {
                                const stmt = dbSync.prepareSync(sql)
                                const rowsArray = stmt.getAllSync(params)
                                stmt.finalizeSync()
                                const rows = {
                                    length: rowsArray.length,
                                    item: (i) => rowsArray[i],
                                    _array: rowsArray,
                                }
                                const result = { rows, rowsAffected: 0, insertId: undefined }
                                success && success(tx, result)
                            } else {
                                const stmt = dbSync.prepareSync(sql)
                                stmt.executeSync(params)
                                stmt.finalizeSync()
                                const changes = dbSync.prepareSync('SELECT changes() as rowsAffected').getFirstSync()
                                const lastId = /\bINSERT\b/i.test(sql)
                                    ? dbSync.prepareSync('SELECT last_insert_rowid() as insertId').getFirstSync()
                                    : { insertId: undefined }
                                const result = {
                                    rows: { length: 0, item: () => undefined, _array: [] },
                                    rowsAffected: changes?.rowsAffected ?? 0,
                                    insertId: lastId?.insertId,
                                }
                                success && success(tx, result)
                            }
                        } catch (e) {
                            if (error) return error(tx, e)
                            throw e
                        }
                    },
                }
                callback && callback(tx)
                successCallback && successCallback()
            } catch (e) {
                errorCallback && errorCallback(e)
            }
        },
    }

    return facade
}

export const db = openDatabase()


class _ErrorServices {
    constructor() {
        this.db = db
    }

    getErrorLogs = () => {
        return new Promise((resolve, reject) => {

            if (isWeb()) {
                resolve([])
                return
            }

            this.db.transaction(tx => {
                tx.executeSql(
                    `SELECT * FROM ${TABLE_ERROR_LOGS}`,
                    [],
                    (_, { rows: { _array } }) => {
                        resolve(_array)
                    },
                    (_, error) => {
                        reject(error)
                    }
                )
            })
        })
    }

    addErrorLog = (dataError) => {
        console.log('56 --- addErrorLog: Error log', dataError)
        return new Promise((resolve, reject) => {
            console.log('Error log', dataError)
            const {user_id, log, date, connect_status, endpoint, additional} = dataError

            if (isWeb()) {
                resolve([])
                return
            }

            this.db.transaction(tx => {
                tx.executeSql(
                    `INSERT INTO ${TABLE_ERROR_LOGS} 
                    (
                        user_id,
                        log,
                        date,
                        connect_status,
                        endpoint,
                        additional
                    ) 
                    VALUES (?, ?, ?, ?, ?, ?)`,
                    [user_id, log, date, connect_status, endpoint, additional],
                    (_, { insertId }) => {
                        console.log('80 -- registro insertado con exito: ', insertId)
                        resolve(insertId)
                    },
                    (_, error) => {
                        reject(error)
                    }
                )
            })
        })
    }

    deleteRegistersErrorLogs = () => {
        return new Promise((resolve, reject) => {
            if (isWeb()) {
                resolve([])
                return
            }

            this.db.transaction(tx => {
                tx.executeSql(
                    `DELETE FROM ${TABLE_ERROR_LOGS}`,
                    [],
                    (_, { rows: { _array } }) => {
                        resolve(_array)
                    },
                    (_, error) => {
                        reject(error)
                    }
                )
            })
        })
    }
}

export const ErrorServices = new _ErrorServices(db)
